import React, { Component } from "react";
import { connect } from "react-redux";
import ProTypes from "prop-types";
import { Table, Modal, message } from "antd";
import { usrRole } from "../../utils/dataUtil";
import {
  req_list_ssp_school_target_detail,
  req_delete_ssp_school_target_detail,
  req_edit_ssp_school_target_detail,
} from "../../api";

class StudentSourceDetailView extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    schoolcode: ProTypes.string.isRequired,
    planAcademicYear: ProTypes.string.isRequired,
    yearMonth: ProTypes.string.isRequired,
    collegeCode: ProTypes.string,
    refreshdata: ProTypes.func,
  };
  state = {
    modify: true,
    loading: false,
    userLevel: "NORMAL",
    data: [],
    obj: {},
    isAddModal: false,
  };

  componentWillMount() {
    this.api_list_item();
  }

  api_list_item = async () => {
    const { planAcademicYear, schoolcode } = this.props;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ loading: true, userLevel: userLevel });
    const result = await req_list_ssp_school_target_detail(
      userCode,
      userLevel,
      planAcademicYear,
      schoolcode,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items, loading: false });
    } else {
      const items = [];
      this.setState({ data: items, loading: false });
    }
  };

  api_list_item_noloading = async () => {
    const { planAcademicYear, schoolcode } = this.props;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, data: [] });
    const result = await req_list_ssp_school_target_detail(
      userCode,
      userLevel,
      planAcademicYear,
      schoolcode,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items });
    } else {
      const items = [];
      this.setState({ data: items });
    }
  };

  api_delete_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_delete_ssp_school_target_detail(key, token);

    if (result.status === "success") {
      this.handle_data_refresh();
    } else {
    }
  };

  api_edit_item = async (row) => {
    const { token, userCode } = this.props.user;
    row.RecordEditorId = userCode;
    await req_edit_ssp_school_target_detail(row, token);
    this.handle_data_refresh();
  };

  handle_data_refresh = () => {
    this.api_list_item_noloading();
    this.props.refreshdata();
  };

  handle_show_ui_modal = (modal, item) => {
    const { Gid } = item;
    switch (modal) {
      case "add":
        const obj = {
          planAcademicYear: this.props.planAcademicYear,
          highSchoolCode: this.props.schoolcode,
          yearMonth: this.props.yearMonth,
        };
        this.setState({ isAddModal: true, obj: obj });
        break;
      case "delete":
        Modal.confirm({
          title: `您確定刪除此筆生源規劃`,
          onOk: () => {
            this.api_delete_item(Gid);
          },
        });
        break;
      case "download":
        break;
      default:
    }
  };

  handle_ui_field_change = (target_key, target_field, e) => {
    const { userCode } = this.props.user;
    let value = e.target.value;
    let getValue = parseInt(value, 10);

    if (isNaN(getValue)) {
      getValue = 0;
    }

    if (getValue <= 100 && getValue >= 0) {
      const item = {
        Gid: target_key,
        NumberOfPeople: getValue,
        RecordEditorId: userCode,
        condition: target_field,
      };
      //console.log(target_key)
      this.api_edit_item(item);
    } else {
      message.info("數字僅能介於0至100");
    }
  };

  render() {
    const { data, loading } = this.state;
    const { collegeCode } = this.props;
    const columns = [
      {
        title: "學制",
        align: "center",
        dataIndex: "AcademicSystem",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
                background:
                  record.CollegeCode === collegeCode ? "#FFD700" : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "學院",
        dataIndex: "CollegeName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
                background:
                  record.CollegeCode === collegeCode ? "#FFD700" : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "系所",
        dataIndex: "TargetDepartmentName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
                background:
                  record.CollegeCode === collegeCode ? "#FFD700" : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "負責人",
        align: "center",
        dataIndex: "TwName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
                background:
                  record.CollegeCode === collegeCode ? "#FFD700" : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "招生管道",
        dataIndex: "SourceName",
        render(text, record) {
          return {
            props: {
              style: {
                fontWeight: 900,
                background:
                  record.CollegeCode === collegeCode ? "#FFD700" : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "生源科班",
        dataIndex: "HighSchoolDepartmentName",
        render(text, record) {
          return {
            props: {
              style: {
                fontWeight: 900,
                background:
                  record.CollegeCode === collegeCode ? "#FFD700" : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "預收員額",
        width: "50px",
        align: "center",
        fixed: "true",
        dataIndex: "NumberConfident",
        render(text, record) {
          return {
            props: {
              style: {
                color: "green",
                fontWeight: 900,
                background:
                  record.CollegeCode === collegeCode ? "#FFD700" : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "規劃員額",
        width: "50px",
        align: "center",
        fixed: "true",
        dataIndex: "NumberOfPeople",
        render(text, record) {
          return {
            props: {
              style: {
                color: "blue",
                fontWeight: 900,
                background:
                  record.CollegeCode === collegeCode ? "#FFD700" : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
    ];

    return (
      <>
        <Table
          bordered
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(StudentSourceDetailView);
